import React from "react";
import classNames from "classnames";
import { Modal, ModalBody } from "shared/components/modal";
import Size from "shared/enums/Size";
import CheckBox from "shared/form/core/checkbox";
import Button from "shared/components/button";
import { AlertModalType } from "./type";
import Variant from "shared/enums/Variant";
import { useCopies } from "shared/hooks/useCopies";
import isString from "lodash/isString";
import ButtonGroup from "../button/components/buttonGroup";

function AlertModal({
  additionalConfirmation = false,
  additionalConfirmationOptional = false,
  primaryButtonVariant = Variant.ERROR,
  secondaryButtonVariant = Variant.PRIMARY,
  primaryButtonIsOutlined = false,
  secondaryButtonIsOutlined = true,
  handleConfirm,
  ...props
}: AlertModalType) {
  const copies = useCopies();
  const [checked, setChecked] = React.useState(false);
  const handleClick = React.useCallback(() => {
    setChecked(c => !c);
  }, []);

  const disabled =
    (additionalConfirmation && !additionalConfirmationOptional ? !checked : false) || props.primaryButtonDisabled;

  const confirmClickHandler = React.useCallback(() => {
    handleConfirm?.({ additionalConfirmationChecked: checked });
  }, [handleConfirm, checked]);

  return (
    <Modal size={Size.SMALL} className={classNames("alertModal", props.className)}>
      {props.handleDismiss && (
        <Button.Close
          className="alertModal_dismissButton"
          title={copies.get("close")}
          variant={Variant.ERROR}
          onClick={props.handleDismiss}
        />
      )}
      <ModalBody>
        <div className="alertModal_content">
          {props.title && <h4>{props.title}</h4>}
          {isString(props.message) ? <p dangerouslySetInnerHTML={{ __html: props.message }} /> : props.message}
          {additionalConfirmation && (
            <CheckBox
              name="additionalConfirmation"
              className="alertCheckbox"
              size={Size.SMALL}
              label={props.additionalConfirmationMessage || copies.get("i.understand")}
              onChange={handleClick}
              checked={checked}
            />
          )}
          <ButtonGroup className="mt-16">
            {handleConfirm && (
              <Button
                variant={primaryButtonVariant}
                onClick={confirmClickHandler}
                disabled={disabled}
                isOutline={primaryButtonIsOutlined}
                icon={props.primaryButtonIcon}
                label={props.primaryButtonText || copies.get("yes")}
              />
            )}
            {props.handleClose && !props.hideSecondaryButton && (
              <Button
                variant={secondaryButtonVariant}
                isOutline={secondaryButtonIsOutlined}
                onClick={props.handleClose}
                icon={props.secondaryButtonIcon}
                label={props.secondaryButtonText || copies.get("no")}
              />
            )}
          </ButtonGroup>
        </div>
      </ModalBody>
    </Modal>
  );
}

export default AlertModal;
